import { Chunker } from "../Chunker/Chunker";
import { Future } from "../Future/Future";

export class Chunk<T> implements Chunker.IChunk<T> {
    // ========================================================================
    #items: T[] = [];
    #promise: Future<void> = new Future();
    #canSave = true;
    #options: Chunker.ChunkOptions<T>;
    readonly id = Symbol(`chunk-${Date.now()}`);

    // ========================================================================
    constructor(options: Chunker.ChunkOptions<T>) {
        this.#options = options;
    }

    // ========================================================================
    get hasCapacity(): boolean {
        return this.#items.length < this.#options.size;
    }

    // ========================================================================
    /**
     * Adds an entity to the chunk.
     *
     * If the chunk reaches its capacity, it is processed.
     */
    add(entity: T): Promise<void> {
        this.#items.push(entity);
        if (!this.hasCapacity) {
            this.process();
        }
        return this.#promise.promise;
    }

    // ========================================================================
    process(): Promise<void> {
        if (!this.#canSave) return this.#promise.promise;

        this.#canSave = false;
        try {
            this.#options
                .processFn(this.#items)
                .then(() => this.#promise.resolve())
                .catch((e) => this.#promise.reject(e));
        } catch (e) {
            this.#promise.reject(e);
        }

        return this.#promise.promise;
    }
}

export declare namespace Chunk {}
